<template>
  <div>

    <div style="padding-bottom: 30px;"></div>

    <el-row>
      <el-col :span="4" style="padding-bottom: 20px;font-weight: bolder">钱包户转账支持币种配置：</el-col>
    </el-row>
    <el-row>
      <el-col :span="19">
        <check-plugs :val="walletCoins" :items="supportCoins" @value="setWalletCoin"></check-plugs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="padding-top: 20px;">
        <el-button type="success" @click="configWalletCoins">确认提交</el-button>
      </el-col>
    </el-row>

    <div style="padding-bottom: 30px;"></div>

    <el-row>
      <el-col :span="4" style="padding-bottom: 20px;font-weight: bolder">内部转账支持币种配置：</el-col>
    </el-row>
    <el-row>
      <el-col :span="19">
        <check-plugs :val="innerCoins" :items="supportCoins" @value="setInnerCoin"></check-plugs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="padding-top: 20px;">
        <el-button type="success" @click="configInnerCoins">确认提交</el-button>
      </el-col>
    </el-row>


    <div style="padding-bottom: 30px;"></div>
    <el-row>
      <el-col :span="4" style="padding-bottom: 20px;font-weight: bolder">空投币种配置：（默认只支持USDT）</el-col>
    </el-row>
    <el-row>
      <el-col :span="19">
        <check-plugs :val="airdropCoins" :items="supportCoins" @value="setAirdropCoin"></check-plugs>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="padding-top: 20px;">
        <el-button type="success" @click="configAirdropCoins">确认提交</el-button>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import checkboxPlugs from '../../../components/checkbox';
import '../store';
import {mapActions, mapState} from 'vuex';
import api from '../api';

export default {
  name: "transferCoinSet",
  components: {'check-plugs': checkboxPlugs},
  created() {
    this.getSupportCoins();
    api.getWalletSupCoin().then(response => {
      this.walletCoins = response.data;
    });
    api.getInnerSupCoin().then(response => {
      this.innerCoins = response.data;
    });
    api.getAirDropSupCoin().then(response => {
      this.airdropCoins = response.data;
    })
  },
  data() {
    return {
      walletCoins: [],
      innerCoins: [],
      airdropCoins: []
    }
  },

  computed: {
    ...mapState('transfer', ['supportCoins'])
  },

  methods: {
    ...mapActions('transfer', ['getSupportCoins', 'setWalletCoins', 'setInnerCoins' ,'setAirdropCoins']),

    setWalletCoin(val) {
      this.walletCoins = val;
    },

    setInnerCoin(val) {
      this.innerCoins = val;
    },
    setAirdropCoin(val) {
      this.airdropCoins = val;
    },
    configWalletCoins() {
      this.setWalletCoins(this.walletCoins).then(() => {
        this.$message.success("配置成功");
      })
    },

    configInnerCoins() {
      this.setInnerCoins(this.innerCoins).then(() => {
        this.$message.success(("配置成功"));
      })
    },
    configAirdropCoins() {
      this.setAirdropCoins(this.airdropCoins).then(() => {
        this.$message.success(("配置成功"));
      })
    }
  }
}
</script>

<style scoped>

</style>